import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from '@cian/newbuilding-utils';

import { Suggest } from '../../../components/Suggest';
import { TTypedThunkDispatch } from '../../../types/thunk';
import { MOSCOW_AND_MOSCOW_AREA_ID } from '../../../constants/geo';
import { onSuggestionSelect } from '../../../actions/suggest';
import { TSuggestionSelectedItem } from '../../../types/suggestions';
import { getOffersData } from '../../../actions/offersData';
import { getRegionId, selectBoundedBy } from '../../../selectors/currentRegion';
import { FILTER_SELECTION_TIMEOUT } from '../../../constants/timeouts';

const NAME_AND_PLACEHOLDER = 'Адрес, ЖК или Застройщик';

export const GeoInput: React.FC = React.memo(() => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const regionId = useSelector(getRegionId);
  const boundedBy = useSelector(selectBoundedBy);

  const applyFilter = React.useCallback(() => {
    dispatch(getOffersData());
  }, [dispatch]);

  const applyFilterDebounced = React.useRef(debounce(FILTER_SELECTION_TIMEOUT, applyFilter));

  React.useEffect(() => {
    applyFilterDebounced.current = debounce(FILTER_SELECTION_TIMEOUT, applyFilter);
  }, [applyFilter]);

  const handleSuggestionSelect = React.useCallback(
    (item: TSuggestionSelectedItem) => {
      dispatch(onSuggestionSelect(item));
      applyFilterDebounced.current();
    },
    [dispatch],
  );

  return (
    <Suggest
      placeholder={NAME_AND_PLACEHOLDER}
      ariaLabel={NAME_AND_PLACEHOLDER}
      locationId={regionId || MOSCOW_AND_MOSCOW_AREA_ID}
      onSuggestionSelect={handleSuggestionSelect}
      boundedBy={boundedBy}
    />
  );
});

GeoInput.displayName = 'GeoInput';
